module.exports = __webpack_public_path__ + "static/media/LogoBankID.f6e58c38.svg";